export default __webpack_public_path__ + "static/media/storm-360.022c4e06.svg";